"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableEvents = exports.TableEventKind = void 0;
const nanoid_1 = require("nanoid");
const Snapshot_1 = require("../../model/Snapshot");
var TableEventKind;
(function (TableEventKind) {
    TableEventKind["Created"] = "poker:table:created";
    TableEventKind["Started"] = "poker:table:started";
    TableEventKind["Paused"] = "poker:table:paused";
    TableEventKind["Reset"] = "poker:table:reset";
    TableEventKind["Finished"] = "poker:table:finished";
    TableEventKind["StreetFinished"] = "poker:table:street:finished";
    TableEventKind["HandNew"] = "poker:table:hand:new";
    TableEventKind["HandCurrentPlayer"] = "poker:table:hand:current_player";
    TableEventKind["HandDealtCards"] = "poker:table:hand:dealt";
    TableEventKind["HandAllPlayersAllIn"] = "poker:table:hand:all_players_allin";
    TableEventKind["HandEveryoneFolded"] = "poker:table:hand:everyone_folded";
    TableEventKind["HandShowdown"] = "poker:table:hand:showdown";
    TableEventKind["HandWinners"] = "poker:table:hand:winners";
    TableEventKind["HighestBetPlayer"] = "poker:table:highest:bet_player";
    TableEventKind["PlayerJoined"] = "poker:table:player:joined";
    TableEventKind["PlayerWaitlisted"] = "poker:table:player:waitlisted";
    TableEventKind["PlayerObserver"] = "poker:table:player:observer";
    TableEventKind["PlayerOut"] = "poker:table:player:out";
    TableEventKind["PlayerForeverOut"] = "poker:table:player:foreverout";
    TableEventKind["PlayerLeft"] = "poker:table:player:left";
    TableEventKind["PlayerPostedBlind"] = "poker:table:player:post_blind";
    TableEventKind["Disconnected"] = "poker:table:player:disconnected";
    TableEventKind["PlayerBet"] = "poker:table:player:bet";
    TableEventKind["PlayerAllIn"] = "poker:table:player:allin";
    TableEventKind["PlayerChecked"] = "poker:table:player:checked";
    TableEventKind["PlayerCalled"] = "poker:table:player:called";
    TableEventKind["PlayerFolded"] = "poker:table:player:folded";
    TableEventKind["PlayerReset"] = "poker:table:player:reset";
    TableEventKind["PlayerOutOfChips"] = "poker:table:player:outofchips";
    TableEventKind["PlayerBuyIn"] = "poker:table:player:buyin";
    TableEventKind["PlayerSitOut"] = "poker:table:player:sitout";
    TableEventKind["PlayerEndOfTurn"] = "poker:table:player:endofturn";
    TableEventKind["DoNoActionForPlayerEvent"] = "poker:table:player:doNoActionForPlayerEvent";
    TableEventKind["ShowCardsForTeacherEvent"] = "poker:table:player:showCardsForTeacherEvent";
    TableEventKind["HideCardsForTeacherEvent"] = "poker:table:player:hideCardsForTeacherEvent";
    TableEventKind["CaptureLastAction"] = "poker:table:player:captureLastAction";
    TableEventKind["AutoStart"] = "poker:table:auto:start";
    TableEventKind["RankedHandEvent"] = "poker:table:player:rankedHandEvent";
    TableEventKind["CalculateNextBlindEvent"] = "poker:table:calculate:nextBlindEvent";
    TableEventKind["TournamentBlindEvent"] = "poker:table:tournament:BlindEvent";
    TableEventKind["PlayerRemovedByTeacherEvent"] = "poker:table:player:removedByTeacherEvent";
    TableEventKind["SetPlayerBuyInEvent"] = "poker:table:player:BuyInEvent";
})(TableEventKind = exports.TableEventKind || (exports.TableEventKind = {}));
class TableEvents {
    static tableCreatedEvent(table) {
        return TableEvents.createEvent(TableEventKind.Created, table);
    }
    static tableStartedEvent(table) {
        return TableEvents.createEvent(TableEventKind.Started, table, table.getCurrentPlayer());
    }
    static tablePausedEvent(table) {
        return TableEvents.createEvent(TableEventKind.Paused, table);
    }
    static tableResetEvent(table) {
        return TableEvents.createEvent(TableEventKind.Reset, table);
    }
    static tableFinishedEvent(table) {
        return TableEvents.createEvent(TableEventKind.Finished, table);
    }
    static streetFinishedEvent(table) {
        return TableEvents.createEvent(TableEventKind.StreetFinished, table);
    }
    static handNewEvent(table) {
        return TableEvents.createEvent(TableEventKind.HandNew, table);
    }
    static handCurrentPlayerEvent(table, player) {
        return TableEvents.createEvent(TableEventKind.HandCurrentPlayer, table, player);
    }
    static higestBetPlayerEvent(table, player) {
        return TableEvents.createEvent(TableEventKind.HighestBetPlayer, table, player);
    }
    static handDealtCardsEvent(table) {
        return TableEvents.createEvent(TableEventKind.HandDealtCards, table);
    }
    static handShowdownEvent(table) {
        return TableEvents.createEvent(TableEventKind.HandShowdown, table);
    }
    static handAllPlayersAllIn(table) {
        return TableEvents.createEvent(TableEventKind.HandAllPlayersAllIn, table);
    }
    static handEveryoneFolded(table) {
        return TableEvents.createEvent(TableEventKind.HandEveryoneFolded, table);
    }
    static handWinnersEvent(table) {
        return TableEvents.createEvent(TableEventKind.HandWinners, table);
    }
    static playerEndOfTurn(table) {
        return TableEvents.createEvent(TableEventKind.PlayerEndOfTurn, table, table.getCurrentPlayer());
    }
    static playerJoinedEvent(table, player) {
        return TableEvents.createEvent(TableEventKind.PlayerJoined, table, player);
    }
    static playerWaitlistedEvent(table, player) {
        return TableEvents.createEvent(TableEventKind.PlayerWaitlisted, table, player);
    }
    static playerObserverEvent(table, player) {
        return TableEvents.createEvent(TableEventKind.PlayerObserver, table, player);
    }
    static playerForeverOutEvent(table, player) {
        return TableEvents.createEvent(TableEventKind.PlayerForeverOut, table, player);
    }
    static playerOutEvent(table) {
        return TableEvents.createEvent(TableEventKind.PlayerOut, table);
    }
    static playerLeftEvent(table) {
        return TableEvents.createEvent(TableEventKind.PlayerLeft, table);
    }
    static playerPostedBlind(table, player, bet) {
        return TableEvents.createEvent(TableEventKind.PlayerPostedBlind, table, player, bet);
    }
    static playerBetEvent(table, player, bet) {
        return TableEvents.createEvent(TableEventKind.PlayerBet, table, player, bet);
    }
    static playerAllInEvent(table, player) {
        return TableEvents.createEvent(TableEventKind.PlayerAllIn, table, player);
    }
    static playerCheckedEvent(table, player) {
        return TableEvents.createEvent(TableEventKind.PlayerChecked, table, player);
    }
    static playerCalledEvent(table, player) {
        return TableEvents.createEvent(TableEventKind.PlayerCalled, table, player);
    }
    static playerFoldedEvent(table, player) {
        return TableEvents.createEvent(TableEventKind.PlayerFolded, table, player);
    }
    static playerResetEvent(table) {
        return TableEvents.createEvent(TableEventKind.PlayerReset, table);
    }
    static playerOutOfChipsEvent(table, player) {
        return TableEvents.createEvent(TableEventKind.PlayerOutOfChips, table, player);
    }
    static playerBuyInEvent(table, player) {
        return TableEvents.createEvent(TableEventKind.PlayerBuyIn, table, player);
    }
    static playerSitOutEvent(table) {
        return TableEvents.createEvent(TableEventKind.PlayerSitOut, table);
    }
    static disconnected(table, player) {
        return TableEvents.createEvent(TableEventKind.Disconnected, table, player);
    }
    static doNoActionForPlayerEvent(table) {
        return TableEvents.createEvent(TableEventKind.DoNoActionForPlayerEvent, table);
    }
    static showCardsForTeacherEvent(table) {
        return TableEvents.createEvent(TableEventKind.ShowCardsForTeacherEvent, table);
    }
    static hideCardsForTeacherEvent(table) {
        return TableEvents.createEvent(TableEventKind.HideCardsForTeacherEvent, table);
    }
    static captureLastAction(table) {
        return TableEvents.createEvent(TableEventKind.CaptureLastAction, table);
    }
    static autoStartEvent(table) {
        return TableEvents.createEvent(TableEventKind.AutoStart, table);
    }
    static rankedHandEvent(table) {
        return TableEvents.createEvent(TableEventKind.RankedHandEvent, table);
    }
    static calculateNextBlindEvent(table, player) {
        return TableEvents.createEvent(TableEventKind.CalculateNextBlindEvent, table, player);
    }
    static tournamentBlindEvent(table) {
        return TableEvents.createEvent(TableEventKind.TournamentBlindEvent, table);
    }
    static playerRemovedByTeacherEvent(table, player) {
        return TableEvents.createEvent(TableEventKind.PlayerRemovedByTeacherEvent, table, player);
    }
    static setPlayerBuyInEvent(table, player) {
        return TableEvents.createEvent(TableEventKind.SetPlayerBuyInEvent, table, player);
    }
    static createEvent(eventKind, table, player, bet) {
        let snap;
        if (player && bet) {
            snap = Snapshot_1.TableSnapshotter.forPlayerWithBet(table, player.getId(), bet);
        }
        else if (player) {
            snap = Snapshot_1.TableSnapshotter.forPlayer(table, player.getId());
        }
        else {
            snap = Snapshot_1.TableSnapshotter.forTable(table);
        }
        return {
            id: nanoid_1.nanoid(),
            name: eventKind,
            timestamp: Date.now(),
            kind: eventKind,
            snapshot: snap,
        };
    }
}
exports.TableEvents = TableEvents;
//# sourceMappingURL=TableEvent.js.map